import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { GET_HEADQUARTERS } from "../../graphql/query/Headquarters";

export const useHeadquarters = (setHeadquarters, messageApi, user) => {
  const [getHeadquartersResolver, { error, data }] = useLazyQuery(
    GET_HEADQUARTERS,
    {
      fetchPolicy: "network-only",
    },
  );

  useEffect(() => {
    if (user?._id) {
      getHeadquartersResolver();
    }
  }, [user]);

  useEffect(() => {
    if (error) {
      messageApi.error("Error al obtener sedes");
    }
  }, [error]);

  useEffect(() => {
    if (data?.getHeadquartersResolver) {
      setHeadquarters(data.getHeadquartersResolver);
    }
  }, [data]);
};
